var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ApiModel } from './api-model';
import { TranslationValue } from './translation-value';
import * as moment from 'moment';
var Translation = /** @class */ (function (_super) {
    __extends(Translation, _super);
    function Translation(data) {
        var _this = _super.call(this, data) || this;
        if (data.name) {
            _this.name = new TranslationValue(data.name);
        }
        if (data.longName) {
            _this.longName = new TranslationValue(data.longName);
        }
        if (data.shortName) {
            _this.shortName = new TranslationValue(data.shortName);
        }
        if (data.language && data.language.id) {
            _this.languageId = data.language.id;
        }
        _this.updatedDate = new TranslationValue(_this.updatedDate);
        _this.creationDate = new TranslationValue(_this.creationDate);
        _this.toUpdate = false;
        _this.tooltipContent = "Loading...";
        _this.pictures = _this.pictures.sort(function (a, b) { return a.pictureFormatId - b.pictureFormatId; });
        // pop pictogram and insert into this.pictogram
        _this.pictogram = _this.pictures.pop();
        _this.updatedByUser = data.updatedByUser === '' ? '' : 'Updated by ' + data.updatedByUser;
        return _this;
    }
    Object.defineProperty(Translation.prototype, "lastUpdated", {
        get: function () {
            if (moment(this.updatedDate.value).year() > 1492) {
                return new TranslationValue({
                    value: moment(this.updatedDate.value).format('DD/MM/YYYY'),
                    orderId: this.updatedDate.orderId
                });
            }
            else if (moment(this.creationDate.value).year() > 1492) {
                return new TranslationValue({
                    value: moment(this.creationDate.value).format('DD/MM/YYYY'),
                    orderId: this.creationDate.orderId
                });
            }
            else {
                return null;
            }
        },
        enumerable: true,
        configurable: true
    });
    Translation.prototype.setSavedStatus = function () {
        this.toUpdate = false;
        this.shortName.modified = false;
        this.longName.modified = false;
    };
    return Translation;
}(ApiModel));
export { Translation };



// WEBPACK FOOTER //
// ./src/app/models/translation.ts.pre-build-optimizer.js